<div class="modal-header" style="padding: 1.25rem 1.5rem; border-bottom: 0.5px solid var(--bs-border-color); display: flex; align-items: center; justify-content: space-between;">
    <div style="display: flex; align-items: center; gap: 10px;">
        <div style="width: 36px; height: 36px; border-radius: 8px; background: #E6F1FB; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v3h-7V8z"/>
                <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
        </div>
        <div>
            <p style="font-size: 11px; color: #185FA5; margin: 0; letter-spacing: 0.08em; text-transform: uppercase; font-weight: 500;">Safe &amp; Confidence</p>
            <p style="font-size: 15px; font-weight: 500; margin: 0;">Resumen de servicio</p>
        </div>
    </div>
    <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body" style="padding: 1.25rem 1.5rem;">

    <!-- Tipo y categoría -->
    <div style="display: flex; gap: 8px; margin-bottom: 1.25rem;">
    <span style="font-size: 11px; font-weight: 500; padding: 4px 10px; border-radius: 99px; background: #E6F1FB; color: #0C447C; border: 0.5px solid #B5D4F4;">
      {{ serviceTypeName }}
    </span>
        <span style="font-size: 11px; font-weight: 500; padding: 4px 10px; border-radius: 99px; background: #f5f5f5; color: #555; border: 0.5px solid #ddd;">
      {{ fee?.category }}
    </span>
    </div>

    <!-- Datos del servicio -->
    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; margin-bottom: 1.25rem;">
        <div style="background: #f9f9f9; border-radius: 8px; padding: 10px 12px; border: 0.5px solid #e5e5e5;">
            <p style="font-size: 11px; color: #888; margin: 0 0 2px; letter-spacing: 0.04em;">Fecha inicio</p>
            <p style="font-size: 13px; font-weight: 500; margin: 0;">{{ form?.dateInit }}</p>
        </div>
        <div style="background: #f9f9f9; border-radius: 8px; padding: 10px 12px; border: 0.5px solid #e5e5e5;">
            <p style="font-size: 11px; color: #888; margin: 0 0 2px; letter-spacing: 0.04em;">Fecha término</p>
            <p style="font-size: 13px; font-weight: 500; margin: 0;">{{ form?.dateEnd }}</p>
        </div>
        <div style="background: #f9f9f9; border-radius: 8px; padding: 10px 12px; border: 0.5px solid #e5e5e5;">
            <p style="font-size: 11px; color: #888; margin: 0 0 2px; letter-spacing: 0.04em;">Pasajeros</p>
            <p style="font-size: 13px; font-weight: 500; margin: 0;">{{ form?.passengers }}</p>
        </div>
        <div style="background: #f9f9f9; border-radius: 8px; padding: 10px 12px; border: 0.5px solid #e5e5e5;">
            <p style="font-size: 11px; color: #888; margin: 0 0 2px; letter-spacing: 0.04em;">Pick up</p>
            <p style="font-size: 13px; font-weight: 500; margin: 0;">{{ form?.pickUp }}</p>
        </div>
        <div style="background: #f9f9f9; border-radius: 8px; padding: 10px 12px; border: 0.5px solid #e5e5e5;" *ngIf="form?.returnTime">
            <p style="font-size: 11px; color: #888; margin: 0 0 2px; letter-spacing: 0.04em;">Regreso</p>
            <p style="font-size: 13px; font-weight: 500; margin: 0;">{{ form?.returnTime }}</p>
        </div>
        <div style="background: #f9f9f9; border-radius: 8px; padding: 10px 12px; border: 0.5px solid #e5e5e5;">
            <p style="font-size: 11px; color: #888; margin: 0 0 2px; letter-spacing: 0.04em;">Método de pago</p>
            <p style="font-size: 13px; font-weight: 500; margin: 0;">{{ form?.methodPay }}</p>
        </div>
    </div>

    <!-- Desglose de precios -->
    <div style="border: 0.5px solid #e5e5e5; border-radius: 12px; overflow: hidden; margin-bottom: 1rem;">

        <div style="padding: 10px 14px; border-bottom: 0.5px solid #e5e5e5;">
            <p style="font-size: 11px; font-weight: 500; margin: 0; color: #888; letter-spacing: 0.06em; text-transform: uppercase;">Desglose de precios</p>
        </div>

        <!-- Tarifa base -->
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; border-bottom: 0.5px solid #e5e5e5;">
            <span style="font-size: 13px;">Tarifa base</span>
            <span style="font-size: 13px; font-weight: 500;">{{ baseRate | currency }} MXN</span>
        </div>

        <!-- Complementos -->
        <div *ngFor="let c of complementos"
             style="display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; border-bottom: 0.5px solid #e5e5e5;">
            <div style="display: flex; align-items: center; gap: 8px;">
                <div style="width: 4px; height: 4px; border-radius: 50%; background: #378ADD; flex-shrink: 0;"></div>
                <span style="font-size: 13px; color: #555;">{{ c.label }}</span>
            </div>
            <span style="font-size: 13px; color: #555;">{{ c.monto | currency }} MXN</span>
        </div>

        <!-- Subtotal -->
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; border-bottom: 0.5px solid #e5e5e5; border-top: 0.5px solid #ccc;">
            <span style="font-size: 13px; font-weight: 500;">Subtotal</span>
            <span style="font-size: 13px; font-weight: 500;">{{ subtotal | currency }} MXN</span>
        </div>

        <!-- IVA -->
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; border-bottom: 0.5px solid #e5e5e5;">
            <span style="font-size: 13px; color: #888;">IVA (16%)</span>
            <span style="font-size: 13px; color: #888;">{{ iva | currency }} MXN</span>
        </div>

        <!-- Total -->
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 14px; background: #E6F1FB; border-top: 0.5px solid #B5D4F4;">
            <span style="font-size: 14px; font-weight: 500; color: #0C447C;">Total con IVA</span>
            <span style="font-size: 16px; font-weight: 500; color: #042C53;">{{ totalConIva | currency }} MXN</span>
        </div>
    </div>

    <!-- Nota IVA -->
    <div style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 12px; background: #E6F1FB; border-radius: 8px; border: 0.5px solid #B5D4F4;">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#185FA5" stroke-width="2" style="flex-shrink:0; margin-top:1px">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <p style="font-size: 12px; color: #185FA5; margin: 0; line-height: 1.5;">
            Todos los precios son más IVA. El total mostrado ya incluye el 16% de IVA.
        </p>
    </div>

</div>

<div class="modal-footer" style="padding: 1rem 1.5rem; border-top: 0.5px solid #e5e5e5; display: flex; justify-content: space-between;">
    <button type="button" class="btn btn-primary btn-clipboard-cut me-4" (click)="cancel()">
        <i class="fa fa-arrow-left"></i>
        Regresar
    </button>
    <button type="button" class="btn btn-secondary btn-clipboard-cut" (click)="confirm()">
        <i class="fa fa-arrow-right"></i>
        Confirmar y finalizar
    </button>
</div>
